export default __webpack_public_path__ + "static/media/home-shop-modern-07.c1a36a98.png";